import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';
import { Auth } from 'aws-amplify';

import { environment } from '../../environments/environment';

export interface IUser {
  email: string;
  password: string;
  name: string;
}
@Injectable({
  providedIn: 'root'
})

export class CognitoService {

  private authenticationSubject: BehaviorSubject<any>;

  constructor() {
    Auth.configure({
      Auth: environment.cognito,
    });

    this.authenticationSubject = new BehaviorSubject<boolean>(false);
  }

  public signIn(user: IUser): Promise<any> {
    console.log('userrrrr',user);
    return  Auth.signIn(user.email, user.password)
      .then(() => {
        this.authenticationSubject.next(true);
        return true;
      }).catch(() => {
        this.authenticationSubject.next(false);
        return false;
      });
  }

  public signOut(): Promise<any> {
    return Auth.signOut()
      .then(() => {
        this.authenticationSubject.next(false);
      });
  }

  public isAuthenticated(): Promise<boolean> {
    if (this.authenticationSubject.value) {
      return Promise.resolve(true);
    } else {
      return this.getUser()
        .then((user: any) => {
          if (user) {
            return true;
          } else {
            return false;
          }
        }).catch(() => {
          return false;
        })
        .then((userAuthenticated) => {
          if (userAuthenticated) {
            return this.getRol().then((rolValue) => {
              console.log(rolValue)
              if (rolValue.includes('ADMIN_WAREHOUSE') || rolValue.includes('ACCESS_DEV')) {
                return true;
              } else {
                return false;
              }
            });
          } else {
            return false;
          }
        });
    }
  }

  public getUser(): Promise<any> {

    return Auth.currentUserInfo();
  }

  public getAuthenticatedUser(): Promise<any> {

    return Auth.currentAuthenticatedUser();
  }

  public getRol(): Promise<any>{
    return Auth.currentAuthenticatedUser()
      .then((usuario)=>{
        console.log('userRol', usuario.signInUserSession);
        return usuario.signInUserSession.idToken.payload['cognito:groups'];
      });
  }

  public getSession(): Promise<any> {
    return Auth.currentSession();
  }
  
}
